module.exports = __webpack_public_path__ + "img/Nutrition.4fe990b4.svg";